"use client";

import React from "react";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { ArrowRight, Car } from "lucide-react";
import { cn } from "@/lib/utils";
interface ExtendedEcommerceTerm {
  id: number;
  name: string;
  slug: string;
  taxonomy: string;
  link?: string;
  image_url?: string;
  description?: string;
  count?: number;
}
function VehicleCategoriesConsumer() {
  const {
    terms,
    loading,
    error,
    refetch
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="relative overflow-hidden rounded-xl bg-muted/10">
            <AspectRatio ratio={3 / 4}>
              <div className="h-full w-full animate-pulse bg-muted/20" />
            </AspectRatio>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="mb-4 text-muted-foreground">Unable to load vehicle categories.</p>
        <button onClick={refetch} className="text-primary hover:underline">
          Try Again
        </button>
      </div>;
  }
  if (terms.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {terms.map((termRaw, i) => {
      const term = termRaw as ExtendedEcommerceTerm;
      return <Link key={term.id} to={term.link || "#"} className="group relative block h-full w-full overflow-hidden rounded-xl bg-card shadow-sm transition-all hover:shadow-md" data-index={i}>
            <AspectRatio ratio={3 / 4}>
              {}
              <div className="h-full w-full overflow-hidden">
                {term.image_url ? <img src={term.image_url} alt={term.name} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted">
                    <Car className="h-16 w-16 text-muted-foreground/50" />
                  </div>}
              </div>

              {}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80 transition-opacity duration-300 group-hover:opacity-0" />

              {}
              <div className="absolute bottom-0 left-0 w-full p-6 transition-transform duration-300 group-hover:translate-y-4 group-hover:opacity-0">
                <h3 className="font-sans text-2xl font-bold text-white tracking-tight">
                  {term.name}
                </h3>
                {term.description && <p className="mt-2 line-clamp-2 text-sm text-gray-300">
                    {term.description}
                  </p>}
              </div>

              {}
              <div className="absolute inset-0 flex flex-col items-center justify-center bg-primary/90 p-6 text-center opacity-0 backdrop-blur-sm transition-all duration-300 group-hover:opacity-100">
                <h3 className="mb-2 font-sans text-3xl font-bold text-white">
                  {term.name}
                </h3>
                <div className="mb-6 h-1 w-12 rounded-full bg-white/30" />
                
                <div className="flex flex-col items-center gap-1">
                  <span className="text-5xl font-bold text-white tracking-tighter">
                    {term.count ?? 0}
                  </span>
                  <span className="text-sm font-medium uppercase tracking-widest text-blue-100">
                    Vehicles Available
                  </span>
                </div>

                <div className="mt-8 flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-6 py-2 text-sm font-medium text-white transition-colors hover:bg-white hover:text-primary">
                  View Fleet <ArrowRight className="h-4 w-4" />
                </div>
              </div>
            </AspectRatio>
          </Link>;
    })}
    </div>;
}
export default function VehicleCategories() {
  const wp_term_query_params = {
    taxonomy: "product_cat",
    per_page: 4,
    hide_empty: true,
    orderby: "count",
    order: "desc"
  };
  const wp_term_query = new WP_Term_Query(wp_term_query_params);
  return;
}